<template>
  <v-card dark class="d-flex flex-column" style="height: 100vh">
    <v-card-title class="black white--text">
      <span class="yellow--text mr-2">HYROX</span> Admin
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>

    <v-card-text class="pa-4">
      <v-data-table :headers="headers" :items="reservations" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-text-field v-model="search" label="Suche" class="mx-4" append-icon="mdi-magnify"></v-text-field>
        </template>

        <template v-slot:item.createdBy="{ item }">
          <div v-if="item.createdBy">
            <strong>{{ item.createdBy.vorname }} {{ item.createdBy.nachname }}</strong
            ><br />
            <small>{{ item.createdBy.email }}</small>
          </div>
          <div v-else>Unbekannt</div>
        </template>

        <template v-slot:item.content.ticketDivision="{ item }">
          <v-chip x-small color="grey darken-3" dark>{{ item.content.ticketDivision }}</v-chip>
        </template>

        <template v-slot:item.content.ticketPrice="{ item }"> CHF {{ item.content.ticketPrice }} </template>

        <template v-slot:item.content.status="{ item }">
          <v-chip :color="getStatusColor(item.content.status)" dark small>
            {{ formatStatus(item.content.status) }}
          </v-chip>
        </template>

        <template v-slot:item.created="{ item }">
          {{ formatDate(item.created) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="updateStatus(item, 'sent')" v-if="item.content.status === 'reserved'" v-bind="attrs" v-on="on">
                <v-icon color="blue">mdi-email-check-outline</v-icon>
              </v-btn>
            </template>
            <span>Als 'E-Mail versendet' markieren</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                @click="updateStatus(item, 'canceled')"
                color="red"
                v-if="item.content.status !== 'canceled'"
                v-bind="attrs"
                v-on="on">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>Stornieren / Freigeben</span>
          </v-tooltip>

          <v-tooltip v-if="false" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                @click="updateStatus(item, 'reserved')"
                color="orange"
                v-if="item.content.status === 'canceled'"
                v-bind="attrs"
                v-on="on">
                <v-icon>mdi-restore</v-icon>
              </v-btn>
            </template>
            <span>Wiederherstellen (Reserviert)</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import api from "@/api"

export default {
  data: () => ({
    search: "",
    reservations: [],
    headers: [
      { text: "Kunde", value: "createdBy" },
      { text: "Ticket", value: "content.ticketDivision" },
      { text: "Preis", value: "content.ticketPrice" },
      { text: "Status", value: "content.status" },
      { text: "Datum", value: "created" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  async created() {
    this.reservations = await api.getHyroxAdminReservations()
  },
  methods: {
    formatDate(val) {
      if (!val) return "-"
      // Versucht einen Date-String oder Timestamp zu parsen
      const date = new Date(val)

      // Check ob das Datum valide ist
      if (isNaN(date.getTime())) return val

      return date.toLocaleString("de-CH", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    },
    formatStatus(status) {
      if (status === "sent") return "E-MAIL VERSENDET"
      if (status === "canceled") return "STORNIERT"
      if (status === "reserved") return "RESERVIERT" // Vorher 'open'
      return status ? status.toUpperCase() : "UNBEKANNT"
    },
    getStatusColor(status) {
      if (status === "reserved") return "orange"
      if (status === "sent") return "green"
      if (status === "canceled") return "red"
      return "grey"
    },
    async updateStatus(item, status) {
      let msg = `Status auf ${status} setzen?`

      if (status === "sent") msg = "Bestätigen, dass die E-Mail versendet wurde?"
      if (status === "canceled") msg = "Reservierung wirklich STORNIEREN? Ticket wird freigegeben."
      if (status === "reserved") msg = "Ticket wiederherstellen (auf Reserviert setzen)?"

      if (!confirm(msg)) return

      try {
        await api.updateHyroxStatus(item._id, status)

        // WICHTIG: Lokales Update für sofortiges Feedback ohne Reload
        // Da 'item' eine Referenz auf das Objekt im Array ist, aktualisiert das die Tabelle sofort.
        item.content.status = status

        // Optional: Trotzdem im Hintergrund neu laden, um sicherzugehen
        // this.reservations = await api.getHyroxAdminReservations()
      } catch (error) {
        alert("Fehler beim Aktualisieren: " + error.message)
      }
    },
  },
}
</script>
